import { fetchConsentData } from '../../service/consent-api';
import { ErrorStorage } from '../CookieConsent/ErrorStorage';
import { CONSENT_PATH } from '../Routes/routeNames';
import {
  ConsentAction,
  ConsentContent,
  ConsentInfo,
  ConsentLabels,
  Consents,
} from '../appTypings';
import { Language } from '@yleisradio/areena-types';
import { CookieConsentData, UiActions, UiElementOption } from './types';

export async function getCookieConsentData(
  languageCode: Language,
  onFailure: () => void
): Promise<CookieConsentData | null> {
  try {
    const { localizations } = await fetchConsentData();
    const content = localizations[languageCode];

    const info = getInfo(content);
    const consents = content.consents;
    const actions = getActions(consents);
    const options = getOptions(consents);

    return {
      info,
      consents,
      uiElementOptions: options,
      actions,
    };
  } catch {
    ErrorStorage.setError();
    if (location.href.includes(`/${CONSENT_PATH}`)) {
      onFailure();
    }

    return null;
  }
}

export const getInfo = (consentContent: ConsentContent): ConsentInfo => {
  const info = consentContent.info;
  const selectedInfo: ConsentInfo = {
    ...info,
    header: info?.loggedIn.header || '',
    body: info?.loggedIn.body || '',
  };

  return selectedInfo;
};

export const getActions = (consents: Consents): UiActions => {
  return [
    [ConsentAction.ACCEPT_SELECTED, consents.customize.acceptSelected],
    [ConsentAction.ACCEPT_ALL, consents.acceptAll],
  ];
};

const consentLabelEntries = (object: ConsentLabels) => {
  return Object.entries(object) as [
    keyof ConsentLabels,
    ConsentLabels[keyof ConsentLabels],
  ][];
};

const loggedInOptions = ([, { visibility }]: UiElementOption) =>
  visibility === 'all' || visibility === 'loggedIn';

export const getOptions = (consents: Consents): UiElementOption[] => {
  const { labels } = consents.customize;
  return consentLabelEntries(labels).filter(loggedInOptions);
};
